export default [
  {
    path: '/order',
    name: 'order',
    component: () => import('@/views/menu/order/order.vue'),
    meta: {
      pageTitle: 'مدیریت سفارش ها',
      action: 'show',
      resource: 'OrderManager',
    },
  },
  {
    path: '/ordercategory',
    name: 'ordercategory',
    component: () => import('@/views/menu/order/ordercategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی ها',
      action: 'show',
      resource: 'OrderCategoryManager',
    },
  },
  {
    path: '/ordercategoryprocess',
    name: 'ordercategoryprocess',
    component: () => import('@/views/menu/order/ordercategoryprocess.vue'),
    meta: {
      pageTitle: 'مدیریت فرآیندها',
      action: 'show',
      resource: 'OrderCategoryProcessManager',
    },
  },
  {
    path: '/clinic',
    name: 'clinic',
    component: () => import('@/views/menu/clinic.vue'),
    meta: {
      pageTitle: 'مدیریت درمانگاه ها',
      action: 'show',
      resource: 'ClinicManager',
    },
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: () => import('@/views/menu/invoice.vue'),
    meta: {
      pageTitle: 'مدیریت صورتحساب ها',
      action: 'show',
      resource: 'InvoiceManager',
    },
  },
  {
    path: '/invoice/details/:id',
    name: 'updateinvoice',
    component: () => import('@/views/menu/invoicedetails.vue'),
    meta: {
      pageTitle: 'جزئیات صورتحساب',
      action: 'show',
      resource: 'InvoiceManager',
    },
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/views/menu/payment.vue'),
    meta: {
      pageTitle: 'مدیریت پرداخت ها',
      action: 'show',
      resource: 'PaymentManager',
    },
  },
  {
    path: '/clinictariff',
    name: 'clinictariff',
    component: () => import('@/views/menu/clinictariff.vue'),
    meta: {
      pageTitle: 'مدیریت تعرفه ها',
      action: 'show',
      resource: 'ClinicTariffManager',
    },
  },
  {
    path: '/color',
    name: 'color',
    component: () => import('@/views/menu/order/color.vue'),
    meta: {
      pageTitle: 'مدیریت رنگ ها',
      action: 'show',
      resource: 'ColorManager',
    },
  },
]
